import React, { Component } from 'react';
import { compose } from 'recompose';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';

import { withAuthorization } from '../../session/index';

import { Container, Row, Col, Card, CardHeader } from 'reactstrap';

import CreateYesNoQuestionPost from '../../components/post/create/YesNoQuestionPost';
import CreateOpenQuestionPost from '../../components/post/create/OpenQuestionPost';
import CreateMultipleQuestionPost from '../../components/post/create/MultipleQuestionPost';

import { createPost, getPostByUid, updatePost } from '../../firebase/api/post';
import Information from '../../components/post/information/Information';
import { MULTIPLE, OPEN, RANK, YES_NO } from '../../constants/questions';
import WithRouter from '../../helpers/WithRouter';

class UpdatePost extends Component {
    constructor(props) {
        super(props);

        this.state = {
            post: null,
        };
    }

    componentDidMount() {
        const { location, match } = this.props;
        location.state
            ? this.setState({ post: location.state })
            : getPostByUid(match.params.id).then(res => {
                  this.setState({ post: res });
              });
    }

    updatePost = dto => {
        updatePost(dto)
            .then(res => {
                this.props.navigate(ROUTES.MY_ALL_POSTS);
            })
            .catch(error => {
                this.props.navigate(ROUTES.MY_ALL_POSTS);
            });
    };

    render() {
        const { post } = this.state;
        return (
            <Container fluid className="CreatePost pt-5">
                <div className="pb-5">
                    <Card className="create-post">
                        <CardHeader
                            style={{
                                backgroundColor: '#464a54',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <h6 className="m-0 font-weight-bold text-center text-white">
                                Post an idea
                            </h6>
                        </CardHeader>
                        {post && post.question.type === YES_NO && (
                            <CreateYesNoQuestionPost
                                post={post}
                                onEdit={this.updatePost}
                                isPublished={true}
                            />
                        )}
                        {post && post.question.type === MULTIPLE && (
                            <CreateMultipleQuestionPost
                                post={post}
                                onEdit={this.updatePost}
                                isPublished={true}
                            />
                        )}
                        {post && post.question.type === OPEN && (
                            <CreateOpenQuestionPost
                                post={post}
                                onEdit={this.updatePost}
                                isPublished={true}
                            />
                        )}
                    </Card>
                </div>
            </Container>
        );
    }
}

//const condition = authUser => !!authUser && authUser.acceptPolicy === true;
const condition = authUser => !!authUser;

export default compose(withAuthorization(condition), WithRouter)(UpdatePost);
